// extracted by mini-css-extract-plugin
export default {"toggle":"_1aHMS","tooltip":"_2p8AQ","badge-icon":"_3GHEQ","badgeIcon":"_3GHEQ"};